import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaUsers, FaEuroSign, FaCalendar, FaEye } from 'react-icons/fa';
import axios from 'axios';
import '../styles/Bookings.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function CustomersList() {
  const [customers, setCustomers] = useState([]);
  const [stats, setStats] = useState({ total: 0, totalRevenue: 0, totalBookings: 0 });
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/customers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.customers || []);
      setStats(response.data.stats || { total: 0, totalRevenue: 0, totalBookings: 0 });
    } catch (error) {
      console.error('Error loading customers:', error);
    } finally {
      setLoading(false);
    }
  };

  // Filter
  const filteredCustomers = customers.filter(customer => {
    const matchesSearch = 
      customer.nachname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.vorname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.ort?.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesSearch;
  });

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div className="bookings-page">
      <div className="page-header">
        <div>
          <h1><FaUsers /> Kunden</h1>
          <p className="text-gray">Alle Kunden aus Feierpakete, DJ und Livemusik</p>
        </div>
      </div>

      {/* Stats */}
      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', marginBottom: '2rem' }}>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
            <FaUsers />
          </div>
          <div className="stat-content">
            <h3>{stats.total}</h3>
            <p>Kunden gesamt</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
            <FaEuroSign />
          </div>
          <div className="stat-content">
            <h3>{stats.totalRevenue.toFixed(0)}€</h3>
            <p>Gesamtumsatz</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
            <FaCalendar />
          </div>
          <div className="stat-content">
            <h3>{stats.totalBookings}</h3>
            <p>Buchungen gesamt</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-bar card">
        <div className="search-box">
          <FaSearch />
          <input
            type="text"
            placeholder="Suche nach Name, E-Mail, Ort..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="results-count">
          {filteredCustomers.length} Kunden
        </div>
      </div>

      {/* Customers Table */}
      {filteredCustomers.length === 0 ? (
        <div className="card text-center" style={{ padding: '3rem' }}>
          <FaUsers style={{ fontSize: '3rem', color: '#3b82f6', marginBottom: '1rem' }} />
          <p className="text-gray">Noch keine Kunden vorhanden.</p>
        </div>
      ) : (
        <div className="card">
          <div className="table-responsive">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Kunde</th>
                  <th>E-Mail</th>
                  <th>Telefon</th>
                  <th>Ort</th>
                  <th>Buchungen</th>
                  <th>Umsatz</th>
                  <th>Letzte Buchung</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {filteredCustomers.map(customer => (
                  <tr key={customer.email}>
                    <td>
                      <strong>{customer.vorname} {customer.nachname}</strong>
                    </td>
                    <td>{customer.email}</td>
                    <td>{customer.telefon || '-'}</td>
                    <td>{customer.ort || '-'}</td>
                    <td>
                      <span style={{ 
                        padding: '0.3rem 0.6rem', 
                        borderRadius: '8px', 
                        background: '#e0e7ff',
                        color: '#4338ca',
                        fontWeight: '600'
                      }}>
                        {customer.bookingCount}
                      </span>
                    </td>
                    <td className="text-primary">
                      <strong>{customer.totalRevenue.toFixed(0)}€</strong>
                    </td>
                    <td>
                      {customer.lastBookingDate ? 
                        new Date(customer.lastBookingDate).toLocaleDateString('de-DE') : 
                        '-'
                      }
                    </td>
                    <td>
                      <Link 
                        to={`/kunden/${encodeURIComponent(customer.email)}`} 
                        className="btn-icon"
                        title="Details"
                      >
                        <FaEye />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomersList;
